export class BaseEntity {
	id?: number;
	createdDate?: Date;
	updatedDate?: Date;
}
